<template>
    <b-nav-item-dropdown
        v-if="isNavHorizontal"
        data-top-right-id="help"
        no-caret
        right
    >
        <template slot="button-content">
            <i
                class="fas fa-question-circle"
                :class="{ blink_indicator: hasUnreadNews }"
                :key="helpIconKey"
            ></i>
            <span class="d-lg-none">Help</span>
        </template>
        <b-dropdown-item
            @click="$emit('open-news')"
            data-top-help-id="whats-new"
        >
            <i
                class="fas fa-info-circle"
                :class="{ blink_indicator: hasUnreadNews }"
                style="margin-right: 5px;"
            ></i>
            What's New
        </b-dropdown-item>
        <b-dropdown-item
            @click="$emit('open-helpdesk')"
            data-top-help-id="helpdesk"
        >
            <i class="fas fa-question-circle" style="margin-right: 5px;"></i>
            Help Desk
        </b-dropdown-item>
        <b-dropdown-item
            @click="$emit('open-e-learning')"
            data-top-help-id="e-learning"
        >
            <i class="fas fa-book" style="margin-right: 5px;"></i>
            E-Learning
        </b-dropdown-item>

        <b-dropdown-divider />
        <b-dropdown-item v-b-modal.modalmmsearch data-top-help-id="merck">
            <i class="cus-merck"></i>Merck Vet Manual
        </b-dropdown-item>
    </b-nav-item-dropdown>

    <li v-else data-top-right-id="help" class="left-option">
        <button class="option-toggle" @click="$emit('toggle-visibility')">
            <i
                class="fas fa-question-circle"
                :class="{ blink_indicator: hasUnreadNews }"
                :key="helpIconKey"
            ></i>
            <span class="label">Help</span>
        </button>
        <ul v-if="showOptionMenu" class="option-menu">
            <li>
                <button
                    class="option-menu-item"
                    :class="{ blink_indicator: hasUnreadNews }"
                    @click="$emit('open-news')"
                    data-top-help-id="whats-new"
                >
                    <i
                        class="fas fa-info-circle"
                        :class="{ blink_indicator: hasUnreadNews }"
                        style="margin-right: 5px;"
                    ></i>
                    <span>What's New</span>
                </button>
            </li>
            <li>
                <button
                    class="option-menu-item"
                    @click="$emit('open-helpdesk')"
                    data-top-help-id="helpdesk"
                >
                    <i
                        class="fas fa-question-circle"
                        style="margin-right: 5px;"
                    ></i>
                    <span>Help Desk</span>
                </button>
            </li>
            <li>
                <button
                    class="option-menu-item"
                    @click="$emit('open-e-learning')"
                    data-top-help-id="e-learning"
                >
                    <i class="fas fa-book" style="margin-right: 5px;"></i>
                    <span>E-Learning</span>
                </button>
            </li>
            <b-dropdown-divider />
            <li>
                <button
                    v-b-modal.modalmmsearch
                    class="option-menu-item"
                    data-top-help-id="merck"
                >
                    <i class="cus-merck" style="margin: 0; width: 16px;"></i>
                    <span>Merck Vet Manual</span>
                </button>
            </li>
        </ul>
    </li>
</template>

<script>
export default {
    props: {
        isNavHorizontal: {
            type: Boolean,
            default: true
        },
        showOptionMenu: {
            type: Boolean,
            default: false
        },
        hasUnreadNews: {
            type: Boolean,
            default: false
        },
        helpIconKey: {
            type: Number,
            default: null
        }
    }
};
</script>

<style lang="scss" scoped>
.left-option {
    width: 100%;

    button {
        border: 0;
        outline: 0;
        background: transparent;
        width: 100%;
        font-weight: 500;

        .label {
            flex-grow: 1;
            text-align: start;
        }

        &:hover {
            background: rgba(255, 255, 255, 0.2);
        }

        &:focus-visible {
            box-shadow: 0 0 0 0 #fff, 0 0 0 2px rgba(59, 130, 246, 0.5),
                0 0 #0000;
        }
    }

    .option-toggle {
        display: flex;
        gap: 10px;
        height: 36px;
        align-items: center;
        justify-content: start;
        padding: 8px 12px;
        border-radius: 4px;
        color: #fff;

        span {
            font-size: 0.875rem;
            flex-grow: 1;
            text-align: start;
        }

        .icon {
            width: 16px;
            height: 16px;
            color: #d5d5d5;
        }

        .chevron {
            transition: transform 250ms ease-in-out;

            &.open {
                transform: rotateX(180deg);
            }
        }
    }

    .option-menu {
        display: flex;
        flex-direction: column;
        margin: 4px 0 4px 0;
        padding: 4px 0;
        list-style: none;
        border-radius: 4px;
        background: #fff;
    }

    .option-menu-item {
        display: flex;
        gap: 8px;
        align-items: center;
        padding: 8px 12px 8px 38px;

        font-size: 0.85rem;
        font-weight: 500;

        &:hover {
            background: #c9ccde;
        }

        span {
            font-size: 0.85rem;
        }

        .icon {
            width: 15px;
            height: 15px;
        }
    }
}
</style>
